import { makeStyles } from "tss-react/mui";
import { Nullable } from "@/types/common";

export const useStyles = makeStyles<{
  feedbackRating: Nullable<string>;
  feedbackComment: Nullable<string>;
  feedbackTooSlow: boolean;
  feedbackWrongOutput: boolean;
}>()(
  (
    theme,
    { feedbackRating, feedbackComment, feedbackTooSlow, feedbackWrongOutput }
  ) => ({
    feedbackContainer: {
      width: "100%",
      display: "flex",
      alignItems: "center",
      gap: theme.spacing(3),
    },
    iconButton: {
      display: "grid",
      placeItems: "center",
      color: "#1C1B1F",
      backgroundColor: "transparent",
      border: "none",
      cursor: "pointer",

      "&:hover": {
        color: theme.palette.secondary.main,
      },
    },
    upvote: {
      fontSize: "1rem",
      color:
        feedbackRating === "upvote"
          ? theme.palette.secondary.main
          : theme.palette.primary.light,
    },
    downvote: {
      fontSize: "1rem",
      color:
        feedbackRating === "downvote"
          ? theme.palette.secondary.main
          : theme.palette.primary.light,
    },
    modal: {
      padding: 0,
      width: 480,
      maxWidth: "90vw",
      borderRadius: "1rem",
      overflow: "hidden",
    },
    modalContent: {
      padding: theme.spacing(6),
    },
    modalDescription: {
      fontSize: "0.875rem",
      color: "#86868b",
      marginBottom: theme.spacing(4),
      textAlign: "center",
    },
    presetsContainer: {
      display: "flex",
      gap: theme.spacing(2),
      marginBottom: theme.spacing(4),
    },
    presetButton: {
      flex: 1,
      padding: theme.spacing(3, 4),
      border: "2px solid #d2d2d7",
      borderRadius: "0.75rem",
      backgroundColor: "white",
      color: "#0A1A2F",
      fontSize: "0.875rem",
      fontWeight: 500,
      cursor: "pointer",
      transition: "all 0.2s",

      "&:hover": {
        borderColor: theme.palette.secondary.main,
        backgroundColor: "rgba(255, 58, 75, 0.05)",
      },
    },
    presetButtonActive: {
      borderColor: theme.palette.secondary.main,
      backgroundColor: "rgba(255, 58, 75, 0.05)",
      color: theme.palette.secondary.main,
    },
    textArea: {
      width: "100%",
      padding: theme.spacing(3),
      border: "2px solid #d2d2d7",
      borderRadius: "0.75rem",
      fontSize: "0.875rem",
      fontFamily: "'Geist', sans-serif",
      resize: "none",
      outline: "none",
      transition: "border-color 0.2s",

      "&:focus": {
        borderColor: theme.palette.secondary.main,
      },

      "&::placeholder": {
        color: "#86868b",
      },
    },
    modalActions: {
      display: "flex",
      gap: theme.spacing(3),
      marginTop: theme.spacing(5),
    },
    cancelButton: {
      flex: 1,
      padding: theme.spacing(3.5),
      border: "2px solid #d2d2d7",
      borderRadius: "0.75rem",
      backgroundColor: "white",
      color: "#0A1A2F",
      fontSize: "0.875rem",
      fontWeight: 500,
      cursor: "pointer",
      transition: "all 0.2s",

      "&:hover": {
        borderColor: "#86868b",
        backgroundColor: "#f5f5f5",
      },
    },
    submitButton: {
      flex: 1,
      padding: theme.spacing(3.5),
      border: "none",
      borderRadius: "0.75rem",
      backgroundColor: theme.palette.secondary.main,
      color: "white",
      fontSize: "0.875rem",
      fontWeight: 500,
      cursor: "pointer",
      transition: "background-color 0.2s",

      "&:hover": {
        backgroundColor: theme.palette.secondary.dark,
      },
    },
  })
);
